import angular from 'angular';
import userHandler from './user-handler.module';
import login from './login/login.module';

const DEFAULT_LANGUAGE = 'hu';
const MODULE_NAME = 'headerContainer';
const outerHeight = (el) => {
	var height = el.offsetHeight;
	var style = getComputedStyle(el);

	height += parseInt(style.marginTop) + parseInt(style.marginBottom);
	return height;
};
class HeaderContainerController {
	constructor($mdSidenav, $mdDialog, UserHandlerService, $translate, $cookies, $rootScope, loginService, $timeout,
		CommonConstants, notificationService, $scope, $window, $element) {
		'ngInject';
		this.$mdSidenav = $mdSidenav;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.userHandlerService = UserHandlerService;
		this.$translate = $translate;
		this.$cookies = $cookies;
		this.$rootScope = $rootScope;
		this.loginService = loginService;
		this.layoutId = window.layoutID;
		this.constants = CommonConstants;
		this.notificationService = notificationService;
		this.$scope = $scope;
		this.sideNavIsOpen = false;
		this.isHomePage = window.isHomePage;
		this.$window = $window;
		this.$element = $element;
	}

	$onInit() {
		// todo ezt db-ből vagy sütiből vagy valahonnan inicializálni
		if (this.$cookies.get('language')) {
			this.selectedLanguage = this.$cookies.get('language');
		} else {
			this.selectedLanguage = DEFAULT_LANGUAGE;
		}
		this.changeLanguage(this.selectedLanguage, true);
		this.checkIsLoggedIn();
		if (window.userInfo) {
			this.userInfo = window.userInfo;
			this.$rootScope.userInfo = window.userInfo;
			this.firstName = this.getFirstName();
			this.fullName = this.getFullName();
		}
		this.checkCookies();
		// if (this.isHomePage) {
		// 	angular.element(this.$window).bind('scroll', () => {
		// 		const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
		// 		this.$scope.$apply(()=>{
		// 			if(scrollTop > outerHeight(this.$element[0])) {
		// 				document.body.classList.add('search-header');
		// 			} else {
		// 				document.body.classList.remove('search-header');
		// 			}
		// 		});
		// 	});
		// }

		this.$scope.$watch('$ctrl.sideNavIsOpen', (value) => {
			if (value) {
				angular.element('body').addClass('sidebar-is-open');
				angular.element('html').addClass('sidebar-is-open');
			} else {
				angular.element('body').removeClass('sidebar-is-open');
				angular.element('html').removeClass('sidebar-is-open');
			}
		});
	}

	checkCookies() {
		if (this.$cookies.get('logout') == 'success') {
			this.$cookies.remove('logout');
			this.notificationService.showInfo({
				message: 'logoutSuccessNotification'
			});
		}
		if (this.$cookies.get('login') == 'loginSuccessRegistrationSuccess') {
			this.$cookies.remove('login');
			this.notificationService.showInfo({
				message: 'loginSuccessRegistrationSuccess'
			});
		}
		if (this.$cookies.get('login') == 'loginSuccess') {
			this.$cookies.remove('login');
			this.notificationService.showInfo({
				message: 'loginSuccess'
			});
		}
	}

	getFirstName() {
		if (this.userInfo.name) {
			return this.userInfo.name.split(' ').splice(1, 1).join();
		} else {
			return '';
		}
	}

	getFullName() {
		if (this.userInfo.name) {
			return this.userInfo.name;
		} else {
			return '';
		}
	}

	changeLanguage(language, isFirst) {
		/* let fromLanguage = this.$cookies.get('language');
		if ((fromLanguage == language || isFirst) && this.hasLanguagePrefix()) {*/
		this.selectedLanguage = language;
		this.$translate.use(language);
		this.$cookies.put('language', language);
		/* } else {
			this.selectedLanguage = language;
			this.$translate.use(language);
			this.$cookies.put('language', language);
			this.navigateIfNecessary(language);
		}*/
	}

	hasLanguagePrefix() {
		if (angular.element('body').hasClass('AALT-app')) {
			let pathArray = window.location.pathname.split('/');
			return this.constants.AVAILABLE_LANGUAGES.indexOf(pathArray[1]) > -1;
		} else {
			// nem statikus oldal, nem kell nyeli prefix
			return true;
		}
	}

	navigateIfNecessary(language) {
		if (angular.element('body').hasClass('AALT-app')) {
			let pathArray = window.location.pathname.split('/');
			if (this.constants.AVAILABLE_LANGUAGES.indexOf(pathArray[1]) > -1) {
				pathArray[1] = language;
				window.location.pathname = pathArray.join('/');
			} else {
				window.location.pathname = '/' + language + window.location.pathname;
			}
		}
	}

	collapseMobile() {
		this.$mdSidenav('left').toggle();
	}

	openLoginForm(event) {
		this.loginService.openLoginForm(event);
	}

	openRegistrationForm() {
		this.loginService.openRegistrationForm();
	}

	submitLoginForm() {
		this.loginService.submitLoginForm();
	}

	submitRegistrationForm() {
		this.loginService.submitRegistrationForm();
	}

	logout() {
		this.loginService.logout();
	}

	checkIsLoggedIn() {
		if (window.userInfo) {
			this.$rootScope.isLoggedIn = true;
		}
	}

	toggleOpen($event) {
		angular.element($event.currentTarget).find('span.icon--dropdown.icon-arrow-up').toggleClass('icon--dropdown--is-open');
		angular.element($event.currentTarget).find('ul.sidenav-menu__toggle-list').toggleClass('ng-hide');
	}
}

export default angular.module(MODULE_NAME, [userHandler, login])
	.component('headerContainer', {
		controller: HeaderContainerController,
		templateUrl: 'header-container.html'
	}).name;


